import React, { useMemo, useRef, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Bread from '../components/Breadcrumb'
import {
  NInfo,
  ArticleDetailBread,
  EGetInfoDetail,
  EPostLikeInfo,
  NComment,
  EPostComment,
  EPostVisitInfo,
  EPostCollectInfo,
  EGetVisitInfo,
} from '../../models/constants'
import { Avatar, Input, Button, Tooltip } from 'antd'
import CommentList from '../components/comment'

import { effect, useStore } from '../../dva16'
import './index.less'

const { TextArea } = Input

function ArticleDetail() {
  let { id } = useParams()
  let { infoDetail, infoVisit } = useStore(NInfo)
  let [content, setContent] = useState()

  const handleClickRelease = (id, content) => {
    effect(NComment, EPostComment, { id: Number(id), content, update: true })
    setContent()
  }
  useMemo(() => {
    // effect(NInfo, EGetInfoDetail, { id })
    effect(NInfo, EPostVisitInfo, { id })
    effect(NInfo, EGetVisitInfo, { infoID: id })
  }, [])
  return (
    <div id="container">
      <div id="articleDetail">
        {Bread(ArticleDetailBread, infoDetail.category)}
        <div className="center">
          <div className="left">
            <div className="avatar">
              <Avatar size={100} src={(infoDetail.user && infoDetail.user.icon) || require('../static/avatar.svg')} />
            </div>
            <p>{infoDetail.user && infoDetail.user.nickname}</p>
            <div className="roleName">{infoDetail.user && infoDetail.user.role && infoDetail.user.role.name}</div>
          </div>
          <div className="right">
            <div className="text">
              <div className="textTitle">
                <span>{`${infoDetail.categoryID === 2 ? `【${infoDetail.topic && infoDetail.topic.name}】` : ''}${infoDetail.title}`}</span>
                {infoDetail.isNew === 1 && <img className="new" alt="" src={require('../static/new.svg')} />}
                {infoDetail.isHot === 1 && <img className="hot" alt="" src={require('../static/fire.svg')} />}
              </div>
              <div className="textIcon">
                <span>发布于：{infoDetail.createdAt}</span>
                <img src={require('../static/view.svg')} alt="" />
                <span>{infoDetail.visitCount}</span>
                <img src={require('../static/reply.svg')} alt="" />
                <span>{infoDetail.commentCount}</span>
                <img
                  onClick={() => {
                    effect(NInfo, EPostLikeInfo, { infoID: infoDetail.id, id: infoDetail.id })
                  }}
                  src={infoDetail.myLike ? require('../static/like-2.svg') : require('../static/like.svg')}
                  alt=""
                />
                <span>{infoDetail.likeCount}</span>
              </div>
              <div className="textCenter" dangerouslySetInnerHTML={{ __html: infoDetail.html }}></div>
              <div className="textlike">
                <div
                  onClick={() => {
                    effect(NInfo, EPostCollectInfo, { infoID: infoDetail.id, id: infoDetail.id })
                  }}
                  className={infoDetail.myCollect ? 'collected' : 'like'}
                >
                  <img src={infoDetail.myCollect ? require('../static/favorite.svg') : require('../static/favorite-2.svg')} alt="" />
                  {infoDetail.myCollect ? `已收藏(${infoDetail.collectCount})` : '收藏'}
                </div>
                {/*<div className="share">*/}
                {/*  <img src={require('../static/share-2.svg')} alt="" />*/}
                {/*  分享({infoDetail.shareCount})*/}
                {/*</div>*/}
              </div>
              <div className="textRead">
                <p>浏览({infoVisit ? infoVisit.length : 0})</p>
                {infoVisit &&
                  infoVisit.map((visit, index) => (
                    <Tooltip title={visit.user.nickname} placement="topLeft" key={index + visit}>
                      <Avatar src={visit.user.icon} />
                    </Tooltip>
                  ))}
              </div>
            </div>
            <div className="textArea">
              <h3>发表我的看法</h3>
              <TextArea value={content} onChange={(e) => setContent(e.target.value)} rows={4} />
              <div className="button">
                <Button onClick={() => handleClickRelease(id, content)} className="release">
                  点击发布
                </Button>
              </div>
            </div>
            {CommentList(id)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ArticleDetail
